import type { FeatureStyleNode } from '../feature-style.model';

// =============================================================================
// PARAMS - Feature configuration from widget config
// =============================================================================

/** Range feature parameters */
export interface RangeParams {
  /** Reference to parent function element */
  of: string;
}

export const RANGE_DEFAULT_PARAMS: Omit<RangeParams, 'of'> = {};

/**
 * Default theme for range feature.
 * Light sky-blue shading for the y-intervals the function outputs.
 * Use color shades (e.g. 'sky-50', 'green-100') to control lightness — no separate opacity.
 */
export const RANGE_DEFAULTS: FeatureStyleNode = {
  polygon: {
    visible: true,
    fillColor: 'sky-50',
    strokeWidth: 0,
  },
  line: {
    color: 'sky-300',
    dash: 3,
    strokeWidth: 2,
    visible: true,
  },
};
